<template>
  <div class="">
    <v-menu
      :ref="'menu-' + file.id"
      v-model="menu1"
      :close-on-content-click="false"
      transition="scale-transition"
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" @click="menu1 = !menu1" v-on="on">
          <div class="file-tree-viewer-tag">
            <div
              :key="active_tag.id"
              :class="['single-file-tag', active_tag.color + '-tag']"
            >
              {{ active_tag.name }}
            </div>
          </div>
        </div>
      </template>
      <div>
        <div class="drop-tag-general-wrapp">
          <div class="header-tag-wrapp">
            <div class="file-tree-viewer-tag">
              <div :class="['single-file-tag', active_tag.color + '-tag', 'no-background-tag']">
                {{ active_tag.name }}
              </div>
            </div>
          </div>
          <div class="selection-tag-wrapp">
            <div v-for="single_tag in tag_list" :key="single_tag.id" class="inside-tag-wrapp" >
              <div class="square-checkbox" @click="active_tag.id != single_tag.id  ? switchFileTag(single_tag) : ''">
                <v-icon v-if="active_tag.id == single_tag.id">mdi-check</v-icon>
              </div>
              <div class="file-tree-viewer-tag">
                <div
                  :class="[
                    'single-file-tag',
                    single_tag.color + '-tag',
                    active_tag.id == single_tag.id ? 'selected-tag' : '',
                  ]"
                  @click="active_tag.id != single_tag.id  ? switchFileTag(single_tag) : ''"
                >
                  {{ single_tag.name }}
                </div>
              </div>
            </div>
          </div>
          <div class="footer-tag-wrapp">
            <div class="action-name">{{ $t('components.file_management.filterTag.confirmAndClose') }}</div>
            <div class="action-switch-button" @click="menu1 = false">
                <v-icon>mdi-minus</v-icon>
            </div>
          </div>
        </div>
      </div>
    </v-menu>
  </div>
</template>

<script>
import fileTaggingHandler from "../../apiCallers/promise_handler_db/fileTagging"

export default {
  props: {
    file: Object,
  },
  data() {
    return {
      menu1: false,
      tag_list: [],
      active_tag: null,
    };
  },
  async created() {
    this.tag_list = this.$store.state.availableFileTags;
    console.log("Single file tag switch component",this.$store.state.availableFileTags, this.$store.state.all_files_tags);

    let idx_found = this.$store.state.all_files_tags.findIndex(p=> p.file_id == this.file.id);
    console.log(idx_found)
    if(idx_found < 0){
      this.setActiveTag(this.tag_list[this.tag_list.length - 1]);
    }else{
      console.log("Found file with tag",this.$store.state.all_files_tags[idx_found])
      this.setActiveTag(this.findTagById( this.$store.state.all_files_tags[idx_found].tag));
    }


  },

  methods: {
    async switchFileTag(sel_file_tag)
    {
      console.log("Switching the tag", sel_file_tag, this.file)
      this.file["tag"] = sel_file_tag;
      let temp_arr = [];
      temp_arr.push(this.file);
      await fileTaggingHandler.upsert(this.$route.params.uid, temp_arr, null).then((resp)=>{
        this.$store.state.all_files_tags = resp.data;
        this.setActiveTag(sel_file_tag);
        

      })

    },
    findTagById(tag_id){
      return this.tag_list.filter(p=> p.id == tag_id)[0]
    },
    setActiveTag(sel_tag) {
      this.active_tag = sel_tag;
    },
  },
};
</script>